/* oxlint-disable no-top/no-top-level-side-effects -- Declarative Drizzle schema, like the actor _tables definitions. */
import { crudTable, date, integer, text } from "@-/dev.improve.haniverse.lib.database.table";

/**
 * A quest the learner has unlocked, and whether they have completed it. Unlocking pays the
 * quest's `costHan` once (what its errand costs, e.g. the meal being ordered) and allows any
 * number of attempts; the Han balance subtracts every live row's `costHan`. Completing it sets
 * `completedAt` and `xpEarned`: XP sums the live rows' `xpEarned`, and Rank is derived from that.
 *
 * A row's id is deterministic (`quest:<questId>`), so a quest is paid for once and pays its XP
 * once: unlocking or completing it on two devices collapses to a single row.
 */
export const userQuestTable = crudTable("user_quest", {
  /**
   * China map adcode of the city the quest belongs to, or 0 for a global quest
   * (`GLOBAL_QUEST_ADCODE`), which is offered wherever the learner is.
   */
  adcode: integer("adcode").notNull(),
  /** `null` until an attempt succeeds. */
  completedAt: date("completed_at"),
  costHan: integer("cost_han").notNull().default(0),
  questId: text("quest_id").notNull(),
  unlockedAt: date("unlocked_at").notNull(),
  /** 0 until the quest is completed. */
  xpEarned: integer("xp_earned").notNull().default(0),
});

export type UserQuest = typeof userQuestTable.$inferSelect;
/* oxlint-enable no-top/no-top-level-side-effects */
